export enum MagazineType {
  Post,
  Article,
  Store,
  Banner,
}
export enum DiscountType {}
export enum ContentEventFindMethod {
  Hashtags = 0,
  Search = 1,
  Category = 2,
  LinksAndOthers = 3,
}
